import { get } from "svelte/store";
import AuthStore from "../Auth/Store";

const User = {

};
User.hasAlertType = (alertType) => {
	const alertTypes = get(AuthStore.session.alertTypes);
	for (let i = 0; i < alertTypes.length; i++) {
		if (alertTypes[i].code === alertType) {
			return true;
		}
	}
	return false;
};
User.getCurrentUser = () => {
	return get(AuthStore.session.user);
};

User.hasFeature = (feature) => {
	return get(AuthStore.userInfo).features.indexOf(feature) >= 0;
};
User.hasAnyOfFeatures = (features = []) => {
	for (let i = 0; i < features.length; i++) {
		if (User.hasFeature(features[i])) {
			return true;
		}
	}
	return false;
};
User.vhRestrictedInputs = (type) => { // vessel history
	return get(AuthStore.session.company).getVesselHistoryRestrictedInputs(type);
};
export default User;
